import label from './line.data.label'
import itemStyle from './line.data.itemStyle'
import emphasis from './line.data.emphasis'
import tooltip from './line.data.tooltip'

export default {
  name: "data",
  nickname: "数据",
  desc: "系列中的数据内容数组。数组项通常为具体的数据项。",
  type: "array",
  props: {
    value: {
      name: "value",
      nickname: "值",
      desc: "单个数据项的数值。",
      type: "pureValue",
    },
    name: {
      name: "name",
      nickname: "名称",
      desc: "数据项名称。",
    },
    label,
    itemStyle,
    emphasis,
    tooltip,
  },
}
